<template>
  <div>
    <v-alert border="left" colored-border type="error" elevation="2" v-if="disagree">
      Om verder te gaan moet u akkoord gaan met de Algemene voorwaarden & Privacy
      statement.
    </v-alert>
    <v-dialog v-model="dialog" persistent>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" v-if="avAgree" outlined rounded class="w-100" color="primary">
          <v-icon class="mr-2">mdi-alert-circle</v-icon>Lees meer...
        </v-btn>
        <v-btn v-on="on" v-else color="primary" class="w-100">
          <v-icon left>mdi-check</v-icon>Lees meer...
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="mx-2 py-3 font-weight-bold primary--text">Algemene Voorwaarden & Privacy Statement</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="my-5">
          <iframe style="width: 100%; height: 500px;" src="/assets/general_conditions.pdf"></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text class="ma-3" @click="disAgree">Annuleren</v-btn>
          <v-btn color="primary" class="ma-3" @click="Agree">Accepteren</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "AgvPrivacy",
    props: {
      abc: Boolean
    },
    data() {
      return {
        disagree: false,
        avAgree: true,
        dialog: false
      };
    },
    mounted() {},
    methods: {
      disAgree() {
        this.disagree = true;
        this.avAgree = true;
        this.dialog = false;
        this.$emit("updateBtn", false);
      },
      Agree() {
        this.dialog = false;
        this.avAgree = false;
        this.disagree = false;
        this.$emit("updateBtn", true);
      }
    }
  };
</script>
